import React from 'react';
// import PropTypes from 'prop-types';

const features = [
  {
    label: 'Standard map layers',
    description: 'Radar, Temperature, Wind and Lightning map layers',
    standard: true,
    plus: true,
    teams: true
  },
  {
    label: 'E-mail & Push Alerts',
    standard: true,
    plus: true,
    teams: true
  },
  {
    label: 'Timed alerts (Maintenance alerts)',
    description: 'Get notified for low battery levels, sensor cleaning, and your weather station upkeep needs.',
    standard: true,
    plus: true,
    teams: true
  },
  {
    label: 'Dashboard Management',
    description: 'Easily move, rearrange, and customize your weather tiles',
    standard: true,
    plus: true,
    teams: true
  },
  {
    label: 'Weather forecast',
    standard: '3 days',
    plus: '10 days',
    teams: '15 days'
  },
  {
    label: 'Data history',
    standard: '1 year',
    plus: '3 years',
    teams: '5 years'
  },
  {
    label: 'Basic Graphing',
    description: 'Preset charts measuring individual parameters per - single station with customizable timeframes.',
    standard: true,
    plus: true,
    teams: true
  },
  {
    label: 'Advanced Graphing',
    description: 'Multi Station & Multi Parameter Graphing, Enhanced Graph Controls & Customization, Increased Organization, Increased Export & Data handling Capabilities.',
    descriptionLink: { text: 'Details', modal: 'adgraph' },
    standard: false,
    plus: true,
    teams: true
  },
  {
    label: 'Advanced map layers',
    description: 'Air Quality, Snow Depth, Fires, Tropical Cyclones and Water Map',
    standard: false,
    plus: true,
    teams: true
  },
  {
    label: 'Dashboard Tiles',
    description: 'Growing Degree Days, Heating Degree Days and Cooling Degree Days',
    standard: false,
    plus: true,
    teams: true
  },
  {
    label: 'SMS Alerts',
    description: 'Configurable SMS Alerts',
    standard: false,
    plus: '10 per day',
    teams: '20 per day'
  },
  {
    label: 'Team Alerts',
    description: 'Organize weather alerts for a team. As an admin, you can create custom alert sets and assign them to members, who will receive alerts via email, SMS, or in-app.',
    standard: false,
    plus: false,
    teams: true
  },
  {
    label: 'Map filtering',
    description: 'Customize the stations shown on the map. Select from your own stations, favorited ones, and NOAA sources',
    standard: false,
    plus: false,
    teams: true
  }
]

export default function PlusPlansFeatures({ onClick }) {
  const renderValue = (value) => {
    if (value === true) {
      return <span className="check"></span>
    } else if (value === false) {
      return <span className="x">✕</span>
    } else if (typeof value === 'string') {
      return <span className="text-value">{value}</span>
    }
    return null
  }

  return (
    <div className="payment-plus-plans-features">
      <div className="features-header">
        <div className="header-row">
          <div className="feature-label-header"></div>
          <div className="tier-header standard">
            <h3>Standard</h3>
            <h4>Free</h4>
            <span className="active-badge">✓ Active</span>
          </div>
          <div className="tier-header plus">
            <div className="awn-logo"></div>
            <h4>Individual</h4>
            <button 
              className="btn btn-primary"
              onClick={() => onClick('plus')}
            >
              Upgrade
            </button>
          </div>
          <div className="tier-header teams">
            <div className="awn-logo"></div>
            <h4>Teams</h4>
            <button 
              className="btn btn-primary"
              onClick={() => onClick('teams')}
            >
              Upgrade
            </button>
          </div>
        </div>
      </div>

      <div className="features-body">
        {features.map((feature, index) => (
          <div key={index} className="feature-row">
            <div className="feature-label">
              <strong>{feature.label}</strong>
              {feature.description && (
                <p className="feature-description">
                  {feature.description}
                  {/* {feature.descriptionLink && (
                    <> <a href="#" onClick={(e) => {
                      e.preventDefault()
                      // This would need to be passed through props or handled differently
                      console.log('Open modal:', feature.descriptionLink.modal)
                    }}>{feature.descriptionLink.text}</a></>
                  )} */}
                </p>
              )}
            </div>
            <div className="feature-values">
              <div className="feature-value standard">
                <span className="mobile-label">Standard</span>
                {renderValue(feature.standard)}
              </div>
              <div className="feature-value plus">
                <span className="mobile-label">
                  <div className="awn-logo-mobile"></div>
                  Individual
                </span>
                {renderValue(feature.plus)}
              </div>
              <div className="feature-value teams">
                <span className="mobile-label">
                  <div className="awn-logo-mobile"></div>
                  Teams
                </span>
                {renderValue(feature.teams)}
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

PlusPlansFeatures.propTypes = {};
PlusPlansFeatures.defaultProps = {};
PlusPlansFeatures.displayName = 'PlusPlansFeatures'
